import { LoadingModalPayload } from "../types";

export const loadingModalDefaultProps: LoadingModalPayload = {
  title: "Зачекайте, будь ласка",
  description: "Ми шукаємо ваш транспортний засіб",
};
